// Import necessary libraries/components
import React, { useEffect, useRef, useState } from 'react';
import { TypeAnimation } from 'react-type-animation';
import PlacesAutocomplete from '../../components/PlacesAutocomplete/PlacesAutocomplete';
import { PlacePrediction } from '../../hooks/usePlacesAutocomplete';

interface AnimatedPlaceholderInputProps {
  onSuggestionSelect: (
    suggestion: PlacePrediction,
    sessionToken: string,
    usedNewApi: boolean
  ) => void;
  setHasError: (hasError: boolean) => void;
  hasError: boolean;
  isMobile: boolean;
}

function AnimatedPlaceholderInput({
  onSuggestionSelect,
  setHasError,
  hasError,
  isMobile,
}: AnimatedPlaceholderInputProps) {
  const [isTyping, setIsTyping] = useState(false);
  const [suggestionSelected, setSuggestionSelected] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);
  const handleContainerClick = () => {
    setIsTyping(true);
  };

  const handleKeyDown = () => {
    setIsTyping(true);
  };

  const handleSuggestionSelect = (
    suggestion: PlacePrediction,
    sessionToken: string,
    usedNewApi: boolean
  ) => {
    setHasError(false);
    onSuggestionSelect(suggestion, sessionToken, usedNewApi);
    setSuggestionSelected(true);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (containerRef.current && !containerRef.current.contains(event.target as Node)) {
        // Only set isTyping to false if a suggestion has not been selected
        if (!suggestionSelected) {
          setIsTyping(false);
        }
      }
    };

    document.addEventListener('click', handleClickOutside);

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [suggestionSelected]);

  return (
    <div
      ref={containerRef}
      style={{ maxHeight: '30px' }}
      onKeyDown={handleKeyDown}
      onClick={handleContainerClick}
      tabIndex={0}
    >
      <PlacesAutocomplete
        types={['(regions)']}
        placeholder=''
        className='home-autocomplete'
        onSuggestionSelect={handleSuggestionSelect}
        hasError={hasError}
        isHomeInput
      />
      {!isTyping && !suggestionSelected && (
        <TypeAnimation
          sequence={[
            'Tokyo',
            1000,
            'Barcelona',
            1000,
            'New York',
            1000,
            'Cape Town',
            1000,
            'Bangkok',
            1000,
            'Mexico City',
            1000,
            'Vancouver',
            1000,
            'Amsterdam',
            1000,
          ]}
          speed={25}
          style={{
            fontWeight: 100,
            fontSize: '28px',
            color: 'grey',
            fontStyle: 'italic',
            zIndex: '1',
            opacity: '0.7',
            pointerEvents: 'none',
            position: 'relative',
            top: '-36px',
          }}
          repeat={Infinity}
        />
      )}
    </div>
  );
}

AnimatedPlaceholderInput.displayName = 'AnimatedPlaceholderInput';
export default AnimatedPlaceholderInput;
